import React from 'react'
import './Why.css'
import w1 from "../Images/w1.svg"
import w2 from "../Images/w2.svg"
import w3 from "../Images/w3.svg"
import w4 from "../Images/w4.svg"
import whyimg from "../Images/whyimg.png"
const Why = () => {
    const servicesList = [
        {
            icon: w1,
            alt: "Tailored & Scalable Workflows",
            title: "Tailored & Scalable Workflows",
            description: "Custom CRM solutions designed to match your business processes and grow with your organization.",
        },
        {
            icon: w2,
            alt: "Integration-Ready",
            title: "Integration-Ready",
            description: "Seamless connectivity with ERP, marketing tools, payment gateways, and third-party apps.",
        },
        {
            icon: w3,
            alt: "Mobile-Optimized & Accessible ",
            title: "Mobile-Optimized & Accessible ",
            description: "Manage customer relationships and access critical data anytime, anywhere.",
        },
        {
            icon: w4,
            alt: "Analytics & Ongoing Support",
            title: "Analytics & Ongoing Support",
            description: "Gain actionable insights with robust reporting, continuous monitoring, and performance optimization.",
        }
    ];

    return (

        <div id='crm-why'>
            <div className="section">
                <div className="container">
                    <div className="app-services" id="crm">
                        <div className="services-left">
                            <div>
                                <h2>Custom CRM Software Development Services</h2>
                                <p className='subHeading'>
                                   With BastionEx, we create custom CRM software that streamlines workflows, automates processes, and enhances customer engagement to drive business growth.
                                </p>
                            </div>
                            <div className="services-grid">
                                {servicesList.map((service, index) => (
                                    <div className="service-item" key={index}>
                                        <div className="service-icon">
                                            <img src={service.icon} alt={service.alt} />
                                        </div>
                                        <div className="service-text">
                                            <h4>{service.title}</h4>
                                            <p>{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="services-right">
                            <img src={whyimg} alt="Mobile app development illustration" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Why